// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/ErrorFlyout.scss
// module id = 2207
// module chunks = 0